<template>
  <div>
    <b-media
      v-for="(news, index) in newsData"
      :key="index+1"
      tag="li"
      no-body
      :class="{ selected: selectedNews(news) }"
      @click="openNews(news)"
    >
      <b-media-body>
        <div class="mail-details">
          <div class="mail-items">
           
            <div class="card-title" :class="{'text-disable': !news.active}">
              {{ getTitleNews(news) }}
            </div>
            <small v-if="news.template_name"> {{ news.template_name }} </small>
             <div class="subjects-pills">
              <span class="date">
                <!-- {{
                formatDate(news.dt_create, {
                  dateStyle: "short",
                  timeStyle: "medium",
                })
              }} -->
              {{news.dt_create | luxon}}
              </span>
            
               <!-- <feather-icon
                icon="FlagIcon"
                class="text-danger"
                v-if="isImportant(news.importance)"
                v-b-tooltip.hover.v-secondary
                title="Importante"
                @click.stop="$emit('action-filter-important', news.importance)"
              />              -->
              <span class="actions-btns-card">
                <b-button-toolbar justify>
                  <b-button-group class="mr-2 mb-1" size="sm">
                    <b-button
                      v-if="canDisableNews(news)"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="outline-primary"
                      size="sm"
                      class="btn-icon btn-actions-menu"
                      @click.stop="onDisableNews(news)"
                      v-b-tooltip.hover.v-secondary
                      :title="$t('MANAGE_NEWS_ITEM.Disable')"
                    >
                      <feather-icon icon="EyeOffIcon" />
                    </b-button>
                    <b-button
                      v-if="canEdit(news)"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="outline-primary"
                      size="sm"
                      class="btn-icon btn-actions-menu"
                      @click.stop="onEdit(news)"
                      v-b-tooltip.hover.v-secondary
                      :title="$t('MANAGE_NEWS_ITEM.Edit')"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                      v-if="canErrata(news)"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon btn-actions-menu"
                      @click.stop="onErrata(news)"
                      v-b-tooltip.hover.v-secondary
                      :title="$t('MANAGE_NEWS_ITEM.Errata')"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                      v-if="canCopy(news)"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon btn-actions-menu"
                      @click.stop="onCopy(news)"
                      v-b-tooltip.hover.v-secondary
                      :title="$t('MANAGE_NEWS_ITEM.Duplicate')"
                    >
                      <feather-icon icon="CopyIcon" />
                    </b-button>
                    <b-button
                      v-if="canCancel(news)"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon btn-actions-menu"
                      @click.stop="$emit('action-cancel', news)"
                      v-b-tooltip.hover.v-secondary
                      :title="getCancelTitle(news)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-button-group>
                </b-button-toolbar>
              </span>

              <!-- <b-badge
                v-for="(subject, index) in news.subjectList"
                :key="index + 1"
                pill
                class="mr-50"
                variant="light-primary"
              >
                 {{ subject.name }}
              </b-badge> -->
            </div>
            <!-- {{ news.content }} -->
            <div class="card-hat" v-html="news.content.body.data" :class="{'text-disable': !news.active}" style="margin-right: 100px;">
            </div>
            <div class="news-author" style="display: flex; justify-content: space-between;">
              <small><span style="margin-right: 4px;">{{$t('MANAGE_NEWS_ITEM.SentBy')}}:</span> {{news.author.name}} {{news.author.agency ? `(${news.author.agency})` : ''}} <span style="margin-left: 6px;">[{{formatDate(news.dt_publish ? news.dt_publish : news.dt_create, {
                  dateStyle: "short",
                  timeStyle: "short",
                })}}]</span></small> 
              <div v-if="isSafrasPlatform">
                <feather-icon
                icon="EyeIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'Número de visualizações na plataforma'"
                />
                {{news.read}}
              </div>
            </div>
            <div class="pills">
              <b-badge
                href="#"
                class="mr-25"
                pill
                :variant="`light-primary rounded`"
              >
              <feather-icon
                v-if="isNews(news.layout)"
                icon="FileTextIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'Notícia'"
              />
              <feather-icon
                v-if="isFlashes(news.layout)"
                icon="ZapIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'Pisca'"
              />
              <feather-icon
                v-if="isPodcast(news.layout)"
                icon="MicIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'Podcast'"
              />
              <feather-icon
                v-if="isTVCast(news.layout)"
                icon="TvIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'TVCast'"
              />
              <feather-icon
                v-if="isReport(news.layout)"
                icon="ClipboardIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'Relatório'"
              />  
              <feather-icon
                v-if="isEvent(news.layout)"
                icon="CalendarIcon"
                class="text-primary"
                v-b-tooltip.hover.top="'Evento'"
              />  
              </b-badge>
              
              <b-badge
                href="#"
                v-for="(item, index) in news.subjects"
                :key="item._id + index"
                pill
                class="mr-25"
                v-b-tooltip.click.v-primary
                :variant="`light-primary rounded`"
                @click.stop="$emit('action-filter-subject', item)"
              >
                {{ item.acronym ? item.acronym : item.mnemonic }}
              </b-badge>
              <b-badge
                v-for="(source, index) in news.source"
                :key="source._id + index"
                href="#"
                pill
                class="mr-25"
                v-b-tooltip.click.v-primary
                :variant="`light-primary rounded`"
                @click.stop="$emit('action-filter-origin', source)"
              >
                {{ source.name }}
              </b-badge>
              <b-badge
                href="#"
                class="mr-25"
                pill
                :variant="`light-secondary rounded`"
                v-for="(newsContent, index) in news.newsContent"
                :key="newsContent._id + index"
              >
                {{newsContent.namePtBr}}  
              </b-badge>
              <b-badge
                href="#"
                class="mr-25"
                pill
                :variant="`light-success rounded`"
                v-if="news.highlight"
              >
                Destaque
              </b-badge>
            </div>
            <div class="item-icon-content">
              <feather-icon
                v-if="news.image || news.thumb"
                icon="ImageIcon"
                class="text-secondary"
                v-b-tooltip.hover.v-secondary
                :title="$t('MANAGE_NEWS_ITEM.Image')"
              />
              <feather-icon
                v-if="news.document"
                icon="PaperclipIcon"
                class="text-secondary"
                v-b-tooltip.hover.v-secondary
                :title="$t('MANAGE_NEWS_ITEM.Attachment')"
              />
              <feather-icon
                icon="MicIcon"
                class="text-secondary"
                v-b-tooltip.hover.v-secondary
                :title="$t('MANAGE_NEWS_ITEM.Audio')"
                v-if="news.audio"/>
              <feather-icon
                icon="BookmarkIcon"
                class="text-warning"
                v-if="news.exclusive"
                v-b-tooltip.hover.v-secondary
                :title="exclusiveTooltip(news)"
                @click.stop="$emit('action-filter-exclusive', true)"
              />
              <feather-icon
                icon="FlagIcon"
                class="text-danger"
                v-if="isImportant(news.importance)"
                v-b-tooltip.hover.v-secondary
                :title="$t('MANAGE_NEWS_ITEM.Important')"
                @click.stop="$emit('action-filter-important', true)"
              />
              <feather-icon
                icon="DiscIcon"
                class="text-danger"
                v-if="news.inLive"
                v-b-tooltip.hover.v-secondary
                :title="$t('MANAGE_NEWS_ITEM.InLive')"
                @click.stop="$emit('action-filter-inLive', true)"
              />
              <feather-icon
                icon="ZapIcon"
                class="text-warning"
                v-b-tooltip.hover.v-secondary
                :title="$t('MANAGE_NEWS_ITEM.Flashes')"
                v-if="isFlashes(news.layout)"
                @click.stop="$emit('action-filter-flashes', true)"
              />
              <span class="dot" :class="{'green': news.active, 'red': !news.active}" style="margin-left: 5px;"></span>
            </div>
          </div>

          <!-- <div class="dropdown-action">
            <manage-news-dropdown-actions
              :status="news.event_status"
              @action-edit="$emit('action-edit', news)"
              @action-copy="$emit('action-copy', news)"
              @action-delete="$emit('action-delete', news)"
            ></manage-news-dropdown-actions>
          </div> -->
        </div>
      </b-media-body>
    </b-media>
  </div>
</template>

<script>
import {
  BMedia,
  BMediaBody,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  VBTooltip,
} from "bootstrap-vue";
import { formatDate } from "@core/utils/filter";
import formatFieldHelper from "@/helpers/format-field-helper";
import AppConstants from "@/appConstants";
// import ManageNewsDropdownActions from "./ManageNewsDropdownActions.vue";
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    BMedia,
    BMediaBody,
    BBadge,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    // ManageNewsDropdownActions,
  },
  props: {
    newsData: {
      type: Array,
      required: true,
    },
    currentEventStatusFilter: null,
  },
  computed: {
    // isAllEvent() {
    //   return this.currentEventStatusFilter.id == AppConstants.EVENT_STATUS.ALL;
    // },
  },
  methods: {
    isSafrasPlatform() {
      return this.news.origin.code == AppConstants.ORIGINS.SAFRAS_PLATFORM || this.news.channel.code == AppConstants.CHANNELS.PLATFORM.id
    },
    getTitleNews(news) {
      return news.content.title.data;
    },
    exclusiveTooltip(news) {
      if (news.exclusive) {
        return `${this.$t('MANAGE_NEWS_ITEM.Exclusive')} (${news.clientGroup.map(item => item.name).join(',')})`
      }
      return '';
    },
    getCancelTitle(news) {
      if (news.event_status == AppConstants.EVENT_STATUS.DRAFT) {
        return this.$t('MANAGE_NEWS_ITEM.Delete');
      }
      return this.$t('MANAGE_NEWS_ITEM.Cancel');
    },
    canErrata(news) {
      return news.event_status == AppConstants.EVENT_STATUS.PUBLISHED && (news.channel.findIndex(item => item.code == AppConstants.CHANNELS.LEGACY.id) >= 0);
    },
    onErrata(news) {
      this.currentNewsView = news;
      this.$emit("action-errata", news, true);
    },
    onCopy(news) {
      this.currentNewsView = news;
      this.$emit("action-copy", news);
    },
    onDisableNews(news) {
      this.currentNewsView = news;
      this.$emit("action-disable", news);
    },
    onEdit(news) {
      this.currentNewsView = news;
      this.$emit("action-edit", news);
    },
    canCopy(news) {
      return news.event_status != AppConstants.EVENT_STATUS.DRAFT;
    },
    canDisableNews(news) {
      return (
        news.event_status == AppConstants.EVENT_STATUS.PUBLISHED &&
        news.layout != AppConstants.NEWS_LAYOUT.FLASHES
      );
    },
    canEdit(news) {
      return (
        news.event_status == AppConstants.EVENT_STATUS.SAVED ||
        news.event_status == AppConstants.EVENT_STATUS.SCHEDULED ||
        news.event_status == AppConstants.EVENT_STATUS.DRAFT ||
        news.event_status == AppConstants.EVENT_STATUS.EDITING ||
        news.event_status == AppConstants.EVENT_STATUS.PUBLISHED &&
        news.layout != AppConstants.NEWS_LAYOUT.FLASHES
      );
    },
    canCancel(news) {
      return (
        news.event_status == AppConstants.EVENT_STATUS.SAVED ||
        news.event_status == AppConstants.EVENT_STATUS.SCHEDULED ||
        news.event_status == AppConstants.EVENT_STATUS.DRAFT || 
        news.event_status == AppConstants.EVENT_STATUS.EDITING
      );
    },
    openNews(item) {
      console.log("openNews");
      this.currentNewsView = item;
      this.$emit("open-news-view", item);
    },
  },
  setup() {
    const currentNewsView = ref({});
    const selectedNews = (item) => {
      if (currentNewsView.value) {
        return currentNewsView.value._id == item._id;
      }
      return false;
    };

    const lastEventStatusHist = (data) => {
      if (data.event_status_hist.length == 0) {
        return {
          code: data.event_status,
          name: data.eventStatusName,
          date: data.dt_update ? data.dt_update : data.dt_create,
          user: data.email_update ? data.email_update : data.email_create,
        };
      }
      return data.event_status_hist[data.event_status_hist.length - 1];
    };
    const isImportant = (importantId) => {
      return importantId == AppConstants.IMPORTANT.IMPORTANT.id;
    };
    const getImportantLabel = (importantId) => {
      return formatFieldHelper.getImportantLabel(importantId);
    };
    const getEventStatusName = (data) => {
      if (data.code == 5) {
        return `${data.user} está ${data.name}`;
      }
      return data.name;
    };
    const isNews = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.NEWS;
    };
    const isFlashes = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.FLASHES;
    };
    const isPodcast = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.PODCAST;
    };
    const isTVCast = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.TVCAST;
    };
    const isReport = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.REPORT;
    };
    const isEvent = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.EVENT;
    };
    return {
      getEventStatusName,
      formatDate,
      isImportant,
      getImportantLabel,
      lastEventStatusHist,
      currentNewsView,
      selectedNews,
      isNews,
      isFlashes,
      isPodcast,
      isTVCast,
      isReport,
      isEvent
    };
  },
};
</script>

<style lang="scss" scoped></style>
